import { render, staticRenderFns } from "./bind_taobao.vue?vue&type=template&id=c2bda258&"
import script from "./bind_taobao.vue?vue&type=script&lang=js&"
export * from "./bind_taobao.vue?vue&type=script&lang=js&"
import style0 from "./bind_taobao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports